import { Card } from "@/components/ui/card"
import { cn } from "@/lib/utils"

// The design's plain `.card`: the Card primitive without its default padding,
// gap and shadow, so each Insider section sets its own inner layout.
export function Panel({ className, ...props }) {
  return <Card className={cn("gap-0 rounded-2xl py-0 shadow-none", className)} {...props} />
}

export function Eyebrow({ className, children }) {
  return (
    <span className={cn("inline-flex items-center gap-[6px] text-[10.5px] font-bold tracking-[0.1em] text-ink-3 uppercase [&_svg]:size-[13px]", className)}>
      {children}
    </span>
  )
}

export function SectionHead({ id, eyebrow, title, children }) {
  return (
    <div id={id} className="mx-[2px] mt-[34px] mb-[2px] scroll-mt-4">
      {eyebrow && <Eyebrow className="mb-[4px]">{eyebrow}</Eyebrow>}
      <h2 className="font-display text-[22px] font-bold tracking-[-0.5px] max-[561px]:text-[19px]">{title}</h2>
      {children && <p className="mt-[6px] max-w-[640px] text-[13.5px] leading-[1.55] text-ink-3">{children}</p>}
    </div>
  )
}

export function IconTile({ tone, className, children }) {
  return (
    <div
      className={cn(
        "flex size-9 shrink-0 items-center justify-center rounded-[10px] [&_svg]:size-[18px]",
        tone === "amber" ? "bg-needs-you/15 text-needs-you" : "bg-secondary text-muted-foreground",
        className
      )}
    >
      {children}
    </div>
  )
}
